import type { FaireProductEntity } from "../../entity_types/product";

export const p_zdu7pbb9dc: FaireProductEntity = {
  token: "p_zdu7pbb9dc",
  type: "product",
  name: "My First Bible Stories Padded Treasury Keepsake Book",
  brandToken: "b_75qtacjqim",
  brandName: "Cottage Door Press",
  imageUrl:
    "https://cdn.faire.com/fastly/f1b7f47c75968174fb64c27abebc2b5e51e31d5f0feb6be23dd486b0f74d8e47.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3d0efdf306f39d53de49666f6810062803199333c500c51d6691d24f108978e1.jpeg",
  ],
  priceDollars: 8.53,
  description:
    "Introduce your boy or girl to some of the greatest stories ever told with My First Bible Stories! From creation to resurrection, these Bible stories for kids are sure to entertain while introducing Christian and religious beliefs. This book of bible stories, prayers, and life lessons is wonderful, whether you're looking for an Easter gift, a Christmas title, or simply an addition to the family's little library of Christian books. \n\nThe simple language of this children's bible helps kids ages 4-8 read and understand stories easily\nColorful illustrations to engage children while their grown-ups read aloud to them\nThis sturdy, padded keepsake book is filled with over 100 prayers and inspirational writings\nThis kids Bible encourages bonding between parents and children while praying together\nA great gift for baby showers, baptisms, birthdays, first communions, Easter basket stuffers, and Christmas",
  tags: [],
  msrpDollars: 16.42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:55.857Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
